import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { isAdminDashboard } from 'utils/authScopes';
import { ASQ_RESULT_COLUMNS } from 'utils/asqResultColumns';


const GroupCohortsRow = ({ auth, data, meta }) => {
  const cells = meta.withages ? map(data.childrenSizeByAge, (v, k) => (
    <td key={`${data.groupId}-${data.subgroupId}-${data.cohortId}-${k}`}>{v.size}</td>)) : null;

  return (
    <tr>
      { isAdminDashboard(auth) && <td>{data.partner}</td> }
      <td>{data.tagLabel}</td>
      <td>{data.title}</td>
      <td>{data.level}</td>
      <td>{data.childrenSize}</td>
      { cells }
      <td>{data.completedAsqSe2Count}</td>
      <td>{data.completedAsq3Count}</td>
      { meta.withasq && ASQ_RESULT_COLUMNS.map(({ field }) => (
        <td key={field}>{data[field]}</td>
      )) }
    </tr>
  );
}

GroupCohortsRow.propTypes = {
  auth: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default GroupCohortsRow;
